import { render, staticRenderFns } from "./GastosAMEX.vue?vue&type=template&id=476474d4&"
import script from "./GastosAMEX.vue?vue&type=script&lang=js&"
export * from "./GastosAMEX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GastosAMEX.vue"
export default component.exports